// eslint-disable-next-line no-unused-vars
// import { Author, Agent, AuthorType } from './UserTypes'
export var LocaleTypes;
(function (LocaleTypes) {
    LocaleTypes["EN"] = "en";
    LocaleTypes["NL"] = "nl";
    LocaleTypes["AR"] = "\u0627\u0644\u0639\u0631\u0628\u064A\u0629";
})(LocaleTypes || (LocaleTypes = {}));
export var DeviceTypes;
(function (DeviceTypes) {
    DeviceTypes["MOBILE"] = "mobile";
    DeviceTypes["DESKTOP"] = "desktop";
})(DeviceTypes || (DeviceTypes = {}));
export var Views;
(function (Views) {
    Views["ARTICLE"] = "ARTICLE";
    Views["CONVERSATION"] = "CONVERSATION";
    Views["ARCHIVED_CONVERSATIONS"] = "ARCHIVED_CONVERSATIONS";
    Views["GDPR"] = "GDPR";
    Views["HELPCENTER"] = "HELPCENTER";
    Views["HOME_SCREEN"] = "HOME-SCREEN";
    Views["LAST_CONVERSATION"] = "LAST-CONVERSATION";
    Views["MAILFORM"] = "MAILFORM";
    Views["PAGE"] = "PAGE";
    Views["PRECHAT"] = "PRECHAT";
    Views["WHATSAPP"] = "WHATSAPP";
})(Views || (Views = {}));
